import { toaster } from 'uikit/Toaster'
import { useMutation } from '@tanstack/react-query'
import { api } from 'api'

export const useUpdateCatalogItem = (id: string) => {
  return useMutation({
    mutationFn: (data) => api.referral.updateCatalogItem(id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось обновить данные',
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Событие успешно обновлено',
        type: 'success',
      })
    }
  })
}
